$(function() {
    // Header gradient changer
    $('.navbar-collapse').on('show.bs.collapse hide.bs.collapse', function(e) {
        $(this).parents('.navbar').toggleClass('open');
    });

    // Smooth anchor scrolling
    $('header').on('click', 'a[href^="#"]', function(event) {
        event.preventDefault();

        $('html, body').stop().animate({
            scrollTop: (parseInt($($.attr(this, 'href')).offset().top) - parseInt($('nav.navbar.navbar-fixed-top').outerHeight())) + 'px'
        }, 1000);
    });
    $(document).on('click', 'a[href="/"]', function(event) {
        event.preventDefault();

        $('html, body').stop().animate({
            scrollTop: '0px'
        }, 1000);
    });
})